var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { classNames } from '@progress/kendo-react-common';
import { getDate } from '@progress/kendo-date-math';
import { messages, today } from '../../messages';
import { dateInRange, getToday, isInRange } from '../../utils';
import { MIN_DATE, MAX_DATE } from '../../defaults';
var TodayCommand = /** @class */ (function (_super) {
    __extends(TodayCommand, _super);
    function TodayCommand() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (syntheticEvent) {
            if (!_this.todayIsInRange) {
                return;
            }
            if (_this.props.onClick) {
                _this.props.onClick.call(undefined, {
                    syntheticEvent: syntheticEvent,
                    nativeEvent: syntheticEvent.nativeEvent,
                    value: dateInRange(getToday(), _this.min, _this.max),
                    target: _this,
                    isTodayClick: true
                });
            }
        };
        return _this;
    }
    Object.defineProperty(TodayCommand.prototype, "min", {
        get: function () {
            return this.props.min !== undefined
                ? this.props.min
                : TodayCommand.defaultProps.min;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TodayCommand.prototype, "max", {
        get: function () {
            return this.props.max !== undefined
                ? this.props.max
                : TodayCommand.defaultProps.max;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TodayCommand.prototype, "todayIsInRange", {
        get: function () {
            return isInRange(getToday(), getDate(this.min), getDate(this.max));
        },
        enumerable: true,
        configurable: true
    });
    TodayCommand.prototype.render = function () {
        this.localization = provideLocalizationService(this);
        var todayMessage = this.localization.toLanguageString(today, messages[today]);
        var todayClassNames = classNames('k-nav-today', {
            'k-state-disabled': this.props.disabled
        });
        return (React.createElement("span", { className: todayClassNames, onClick: this.handleClick }, todayMessage));
    };
    TodayCommand.propTypes = {
        max: PropTypes.instanceOf(Date).isRequired,
        min: PropTypes.instanceOf(Date).isRequired,
        onClick: PropTypes.func,
        disabled: PropTypes.bool
    };
    TodayCommand.defaultProps = {
        min: MIN_DATE,
        max: MAX_DATE
    };
    return TodayCommand;
}(React.Component));
export { TodayCommand };
registerForLocalization(TodayCommand);
//# sourceMappingURL=TodayCommand.js.map